import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useState } from 'react';
import { useOverlayContext, useIsMounted } from 'seagull';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export function useUploadLogo(worksAt) {
    const { logoUrl } = worksAt || {};
    const isMounted = useIsMounted();
    const { uploadFileToCloudStorage } = useIoContext();
    const { showErrorToast } = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    const { api, logBI, setWorksAt, setWorkspaces } = useStoreActions();
    const { getState } = useStoreStatic();
    const [logoImage, setLogoImage] = useState(logoUrl || '');
    const [savingLogo, setSavingLogo] = useState(false);
    return {
        savingLogo,
        logoImage,
        async uploadLogo (logo, onError) {
            if (!logo) {
                return {
                    success: true
                };
            }
            logBI(11207);
            const prevLogoImage = logoImage;
            setLogoImage(logo.asDataURL);
            setSavingLogo(true);
            try {
                const logoUploadUrl = await api.business.getLogoUploadURL();
                await uploadFileToCloudStorage(logoUploadUrl, logo.file);
                if (worksAt) {
                    setWorksAt(_object_spread_props(_object_spread({}, worksAt), {
                        logoUrl: logo.asDataURL
                    }));
                    const workspaces = selectors.user.workspaces(getState());
                    if (workspaces) {
                        const updatedWorkspaces = workspaces.map((workspace)=>workspace.id() === worksAt.id ? workspace.setLogoUrl(logo.asDataURL) : workspace);
                        setWorkspaces(updatedWorkspaces);
                    }
                }
                return {
                    success: true
                };
            } catch (err) {
                showErrorToast(commonTexts.toasts.errorSavingLogo(), 'logo-upload-error');
                onError && onError();
                isMounted() && setLogoImage(prevLogoImage);
                return {
                    success: false
                };
            } finally{
                isMounted() && setSavingLogo(false);
            }
        }
    };
}
